// const server_host = 'http://localhost:8080';
declare var process;
const server_host_dev = "https://dev.sensornetworks.co.za";
const server_host_qa = "https://qa.sensornetworks.co.za";
const server_host_prod = "https://production.sensornetworks.co.za";

const ionic_stage = process.env.IONIC_APP_STAGE;

const dev = {
  mode: 'Development',
  isprod: false,
  // manifest2: 'https://storage.googleapis.com/sn-installer-lite-pwa-qa/manifest.json',
  manifest: 'https://sn-installer-lite-development.s3.eu-west-1.amazonaws.com/manifest.json',
};

const prod = {
  mode: 'Production',
  isprod: true,
  manifest: 'https://sn-installer-lite-production.s3.eu-west-1.amazonaws.com/manifest.json',
};

const qa = {
  mode: 'Development',
  isprod: false,
  manifest: 'https://sn-installer-lite-qa.s3.eu-west-1.amazonaws.com/manifest.json',
};


let config = qa;
let server_host = server_host_qa;
if(ionic_stage === "prod"){
  server_host = server_host_prod;
  config = prod;
} else if (ionic_stage === "dev"){
  server_host = server_host_dev;
  config = dev;
} else {
  server_host = server_host_qa;
  config = qa;
}

export const ENV = {
  ...config,
  base: server_host,
  api: server_host + '/sensordesk',
  jwtCredentialAuthority: server_host + '/credentials-authority',
  oauthAuthorizeUrl: server_host + '/credentials-authority/oauth/authorize',
  websocketServerUrl: server_host + '/websocket-server/',
  manifest2: '/manifest.json',
  ios: {
    config: {
      id: 'installer-ios-app',
      password: 'U7KjFwz9wJKCB6Ad'
    }
  },
  android: {
    config: {
      id: 'installer-android-app',
      password: 'zZr6bSGLXxo28aYk'
    }
  }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts